import React from "react";
import { Box } from "@chakra-ui/react";
import ContactForm from "../../../../components/common/ContactForm";
import formContent from "../../../../data/forms.json";
import { Colors } from "../../../../static/static";


function MakeContact({page='homepage'}) {
  const formDescription = formContent.contactFormDescription;
  return (
    <Box id="MakeContact" maxHeight={{base: '120vh',md: '105vh',lg: "105vh", xl: "110vh", desktop: '100vh' }} bg={Colors.bgBlue}
    display="flex" justifyContent="center" alignItems="center">
      <ContactForm
        width={{ base: "100%", md: "100vh", lg: "110vh", xl: "90vh" }}
        height={{ base: "100%", md: "115vh", lg: "105vh", xl: "110vh", desktop: '100vh' }}
        description={formDescription}
        page={page}
      />
    </Box>
  );
}

export default MakeContact;
